var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategory3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 46,
    viewBox: "0 0 37 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2188 45.4273C12.9429 44.1023 8.58748 41.0833 5.15249 36.3702C1.7175 31.6571 0 26.4235 0 20.6694V6.81409L18.2188 0L36.4375 6.81409V20.6694C36.4375 26.4235 34.72 31.6571 31.285 36.3702C27.85 41.0833 23.4946 44.1023 18.2188 45.4273ZM18.2188 17.092L5.46563 26.9724C6.18678 29.3574 7.24954 31.5246 8.65391 33.4742C10.0583 35.4238 11.7283 37.0611 13.6641 38.386V29.5277H22.7734V38.386C24.7092 37.0611 26.3792 35.4238 27.7836 33.4742C29.188 31.5246 30.2507 29.3574 30.9719 26.9724L18.2188 17.092ZM18.2188 4.82665L4.55469 9.93721V20.6694C4.55469 20.8587 4.56418 21.0669 4.58315 21.294C4.60213 21.5212 4.61162 21.7294 4.61162 21.9187L18.2188 11.3568L31.8259 21.9187C31.8259 21.7294 31.8354 21.5212 31.8543 21.294C31.8733 21.0669 31.8828 20.8587 31.8828 20.6694V9.93721L18.2188 4.82665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory3);
export default __webpack_public_path__ + "static/media/category-3.fa5d4ca2348b7e3a2583cdf15e6d5bee.svg";
export { ForwardRef as ReactComponent };